import { Component } from 'react';

const RELOAD_KEY = 'cfr_chunk_reload_at';

// If a lazy chunk fails to load (stale cached build after a deploy), reload once to fetch the fresh bundle.
export class ChunkErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    const msg = String(error?.message || error);
    const stale = error?.name === 'ChunkLoadError' || /Loading chunk|originalFactory|Failed to fetch dynamically imported module|Importing a module script failed/i.test(msg);
    const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
    if (stale && Date.now() - last > 60_000) {
      sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
      window.location.reload();
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="chunk-error-fallback" style={{ minHeight: '60vh', display: 'grid', placeItems: 'center', padding: '2rem', fontFamily: 'Manrope, sans-serif', color: '#1F2A44', textAlign: 'center' }}>
        <div style={{ maxWidth: 420 }}>
          <h1 style={{ fontSize: '1.4rem', margin: '0 0 0.5rem' }}>A newer version of the site is available</h1>
          <p style={{ margin: '0 0 1.25rem', lineHeight: 1.6, color: '#4b5563' }}>Please reload the page to continue. If this keeps happening, open the page in a private window.</p>
          <button type="button" data-testid="chunk-error-reload" onClick={() => { sessionStorage.removeItem(RELOAD_KEY); window.location.reload(); }} style={{ background: '#1F2A44', color: '#fff', border: 'none', borderRadius: 999, padding: '0.8rem 1.5rem', fontWeight: 700, cursor: 'pointer' }}>Reload</button>
        </div>
      </div>
    );
  }
}
